import { isEmpty } from 'lodash';
import React from 'react';

import { Breadcrumbs, BreadcrumbsProps } from '@/components/breadcrumbs';
import { FeaturesToggle } from '@/components/features-toggle';
import { AppNavigation } from '@/components/modules/app-navigation';
import { AppNavigationHeader } from '@/components/modules/app-navigation/header';
import { tv } from '@/utils/styles';

// This component is required to share a base layout between /pages and /app
// routes. This can be removed once we have migrated completely to /app
interface AppLayoutBaseProps {
  children: React.ReactNode;
  breadcrumbItems?: BreadcrumbsProps['items'];
  breadcrumbActions?: React.ReactNode;
}

const AppLayoutBase = ({ children, breadcrumbItems, breadcrumbActions }: AppLayoutBaseProps) => {
  const { featuresToggleButton } = styles();

  return (
    <main>
      <div className={featuresToggleButton()}>
        <FeaturesToggle />
      </div>
      <AppNavigationHeader />
      <AppNavigation>
        {!isEmpty(breadcrumbItems) && breadcrumbItems && (
          <Breadcrumbs items={breadcrumbItems} actions={breadcrumbActions} hideBackArrow />
        )}
        {children}
      </AppNavigation>
    </main>
  );
};

const styles = tv({
  slots: {
    featuresToggleButton: 'absolute right-0 top-0 z-10 px-2',
  },
});

export default AppLayoutBase;
